import { createSelector } from 'reselect';
import _ from 'lodash';
import { initialState } from './reducer';
import { getMsalContext } from "../Azure/helpers";

/**
 * Direct selector to the api state domain
 */

const selectApiDomain = state => state.api || initialState;
export const selectApiRootUrl = () =>
  createSelector(
    selectApiDomain,
    api => api.rootUrl,
  );

export const selectApiKey = () =>
  createSelector(
    selectApiDomain,
    api => api.apiKey,
  );

export const selectPermissions = () =>
  createSelector(
    selectApiDomain,
    api => {
      const permissions = (api.apiKey?.user?.permissions ?? []).filter(p => !!p) ?? [];
      return permissions.map(p => p.name);
    },
  );

export const selectStoredRefreshToken = () =>
  createSelector(
    selectApiDomain,
    api => api.storedRefreshToken,
  );

export const selectUserId = () =>
  createSelector(
    selectApiDomain,
    api => (api?.apiKey?.user?.id ? api.apiKey.user.id : null),
  );

export const selectIsLoggedIn = () =>
  createSelector(
    selectApiDomain,
    api => {
      const context = getMsalContext();
      const accounts = context.getAllAccounts();
      const activeAccount = accounts[0];
      return !!api.apiKey?.valid || !!activeAccount;
    },
  );
export const selectUserRights = () =>
  createSelector(
    selectApiDomain,
    api => api.rights,
  );

export const selectMe = () =>
  createSelector(
    selectApiDomain,
    api => (api.apiKey ? api.apiKey.user : null),
  );

export const selectMyTags = () =>
  createSelector(
    selectApiDomain,
    d => d.myTags,
  );

export const selectGate = id =>
  createSelector(
    selectApiDomain,
    api => api.gates[id],
  );

export const selectWork = id =>
  createSelector(
    selectApiDomain,
    api => api.work[id],
  );

export const selectWorks = ids =>
  createSelector(
    selectApiDomain,
    api => !!_(ids).find(id => api.work[id] > 0),
  );

export const selectError = id =>
  createSelector(
    selectApiDomain,
    api => _.find(api.errors, { id }),
  );

export const selectConfig = () =>
  createSelector(
    selectApiDomain,
    api => api.config,
  );

export const selectErrors = () =>
  createSelector(
    selectApiDomain,
    api => api.errors,
  );

export const selectAppConfig = () =>
  createSelector(
    selectApiDomain,
    api => api.appConfig,
  );

export const selectSessionDisabled = () =>
  createSelector(
    selectApiDomain,
    api => api.disableSession,
  );

export const selectAllState = () =>
  createSelector(
    state => state,
    api => api,
  );
